import {
  SCHEDULE_TYPE,
  ScheduleExecution,
} from '@trustero/trustero-api-web/lib/schedulemanager/schedulemanager_pb'

export enum ScheduleStatus {
  Running = 0,
  Completed = 1,
  Failed = 2,
  Default = 3,
}

export interface SchedulingRowData {
  Id: string
  Name: string
  ExecutionTypes: string
  Frequency: string
  LastRunTime: string
  LastRunStatus: ScheduleStatus
  UsersGetNotified: number
  ScheduleTypes: SCHEDULE_TYPE[]
  Enabled: boolean
  NextRun: string
  Executions: ScheduleExecution[]
  NumRuns: number
}

export interface ScheduleReportData {
  Id: string
  ReportId: string
  ReportName: string
  StartTime: string
  EndTime: string
  Summary: string
  AuditRunId?: string
  ChatId?: string
}
